module.exports = __webpack_public_path__ + "static/media/chevron-left.9c5804b1.svg";